import React from 'react';
import { Area, Bar, Dot, Line } from 'recharts';
import { resolveHSLColor } from '@philips-internal/oswald-ui-utils';
import { ChartClickType, ChartDynamicRenderType } from '../base-chart/base-chart-constants.js';
import { getDynamicContent } from '../base-chart/base-chart-utils.js';
const onDotClick = (item, type, onClick) => {
    onClick({ item, type });
};
const onLineClick = (item, onClick) => {
    onClick({ item, type: ChartClickType.LINE });
};
const onBarClick = (item, onClick) => {
    onClick({ item, type: ChartClickType.BAR });
};
const onAreaClick = (item, onClick) => {
    onClick({ item, type: ChartClickType.AREA });
};
const renderBars = (options) => {
    const { bars, hiddenLegends, onClick } = options;
    return bars.map((bar, index) => {
        const hide = hiddenLegends.includes(bar.dataKey);
        return (React.createElement(Bar, { ...bar, className: "c-chart__bar", fill: resolveHSLColor(bar.fill), hide: hide, key: `c-chart__bar-${index}`, onClick: (payload) => onBarClick(payload, onClick), stroke: resolveHSLColor(bar.stroke) }));
    });
};
const renderLineDot = (options, payload) => {
    const { clickType, dotProps = {}, onClick, onDynamicContentRender, renderType } = options;
    const dynamicContent = getDynamicContent(payload, '', renderType, onDynamicContentRender);
    if (dynamicContent) {
        return dynamicContent;
    }
    const mergedProps = { ...payload, ...dotProps };
    return (React.createElement(Dot, { ...mergedProps, onClick: (payload) => onDotClick(payload, clickType, onClick) }));
};
const buildDot = (dotOptions, payload) => {
    return renderLineDot(dotOptions, payload);
};
const renderLines = (options) => {
    const { activeDot, dot, hiddenLegends, lines, onClick, onDynamicContentRender } = options;
    return lines.map((line, index) => {
        const hide = hiddenLegends.includes(line.dataKey);
        const activeDotOptions = {
            clickType: ChartClickType.ACTIVE_DOT,
            dotProps: activeDot,
            onClick,
            onDynamicContentRender,
            renderType: ChartDynamicRenderType.ACTIVE_DOT,
        };
        const dotOptions = {
            clickType: ChartClickType.DOT,
            dotProps: dot,
            onClick,
            onDynamicContentRender,
            renderType: ChartDynamicRenderType.DOT,
        };
        return (React.createElement(Line, { ...line, activeDot: (payload) => buildDot(activeDotOptions, payload), className: "c-chart__line", dot: (payload) => buildDot(dotOptions, payload), hide: hide, key: `c-chart__line-${index}`, onClick: (payload) => onLineClick(payload, onClick), stroke: resolveHSLColor(line.stroke) }));
    });
};
const renderAreas = (options) => {
    const { activeDot, areas, dot, hiddenLegends, onClick, onDynamicContentRender } = options;
    return areas.map((area, index) => {
        const hide = hiddenLegends.includes(area.dataKey);
        const activeDotOptions = {
            clickType: ChartClickType.ACTIVE_DOT,
            dotProps: activeDot,
            onClick,
            onDynamicContentRender,
            renderType: ChartDynamicRenderType.ACTIVE_DOT,
        };
        const dotOptions = {
            clickType: ChartClickType.DOT,
            dotProps: dot,
            onClick,
            onDynamicContentRender,
            renderType: ChartDynamicRenderType.DOT,
        };
        return (React.createElement(Area, { ...area, activeDot: (payload) => buildDot(activeDotOptions, payload), className: "c-chart__area", dot: (payload) => buildDot(dotOptions, payload), fill: resolveHSLColor(area.fill), hide: hide, key: `c-chart__area-${index}`, onClick: (payload) => onAreaClick(payload, onClick), stroke: resolveHSLColor(area.stroke) }));
    });
};
export { onLineClick, renderAreas, renderBars, renderLines, };
//# sourceMappingURL=axis-chart-utils.js.map